import React from "react";
import { withStyles } from "@material-ui/core/styles";
import firebaseApp from "../services/firebase";
import Input from "@material-ui/core/Input";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import { connect } from "../recontext/store";

const styles = theme => ({
  container: {
    position: "fixed",
    bottom: 0,
    right: 20,
    width: 284,
    zIndex: 1450
  },
  messages: {
    padding: theme.spacing.unit,
    backgroundColor: "#ffffff",
    width: 274,
    border: "1px solid",
    height: 260,
    overflow: "scroll",
    marginBottom: 46
  },
  message: {
    padding: 5
  },
  header: {
    padding: 8,
    backgroundColor: "#3f51b5",
    textAlign: "center",
    color: "#ffffff",
    cursor: "pointer",
    borderRadius: "8px 8px 0 0",
    width: 276
  },
  headerIcon: {
    position: "absolute",
    right: 0,
    top: 8
  },
  input: {
    backgroundColor: "#ffffff",
    width: 280,
    position: "absolute",
    paddingTop: theme.spacing.unit,
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    border: "1px solid",
    left: 0,
    bottom: 0
  },
  white: {
    color: "#ffffff"
  }
});

class Messenger extends React.PureComponent {
  constructor(props) {
    super(props);
    this.messageRef = firebaseApp
      .database()
      .ref()
      .child("messages");

    this.lastItemRef = null;
    this.handleChange = this.handleChange.bind(this);
    this.listenMessages = this.listenMessages.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.toggleMinimize = this.toggleMinimize.bind(this);
    const bodyWidth = document.body.offsetWidth;
    this.state = {
      minimized: bodyWidth < 1024 || localStorage.getItem("CHAT_MINIMIZED"),
      message: "",
      list: []
    };
  }

  componentDidMount() {
    this.listenMessages();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.lastItemRef)
      this.lastItemRef.scrollIntoView({ behavior: "smooth" });
  }

  handleChange(event) {
    this.setState({ message: event.target.value });
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      const { message } = this.state;
      if (!message) return;

      const { user } = this.props;
      const newItem = {
        userId: user.id,
        displayName: user.displayName,
        message: message
      };
      this.messageRef.push(newItem);
      this.setState({
        message: ""
      });
    }
  }

  listenMessages() {
    this.messageRef.limitToLast(200).on("value", message => {
      if (!message || !message.val()) return;
      this.setState({
        list: Object.values(message.val())
      });
    });
  }

  toggleMinimize() {
    const { minimized } = this.state;
    if (minimized) localStorage.removeItem("CHAT_MINIMIZED");
    else localStorage.setItem("CHAT_MINIMIZED", !minimized);
    this.setState({
      minimized: !minimized
    });
  }

  render() {
    const { user, classes } = this.props;
    const { minimized, message, list } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.header} onClick={this.toggleMinimize}>
          <Typography variant="subheading" className={classes.white}>
            Discussion Room
          </Typography>
          <Icon className={classes.headerIcon}>
            {minimized ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </Icon>
        </div>
        {!minimized ? (
          <div className={classes.messages}>
            {list.map((item, index) => (
              <div key={index} className={classes.message}>
                <Typography>
                  <strong>{item.displayName}</strong>: {item.message}
                </Typography>
              </div>
            ))}
            <div ref={ref => (this.lastItemRef = ref)} />
          </div>
        ) : null}
        {!minimized ? (
          <Input
            placeholder={
              !!user ? "Type a message" : "Please Login to join chat room"
            }
            className={classes.input}
            value={message}
            onKeyPress={this.handleKeyPress}
            onChange={this.handleChange}
            disabled={!user}
            inputProps={{
              "aria-label": "message"
            }}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(Messenger));
